import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import FooterBar from './Components/site/FooterBar';
import HeaderBar from './Components/site/HeaderBar';
import { LanguageProvider } from './context/LanguageContext';
import useSiteContent from './hooks/useSiteContent';
import AboutPage from './views/AboutPage';
import BrowsPage from './views/BrowsPage';
import ConsentPage from './views/ConsentPage';
import ContactPage from './views/ContactPage';
import GalleryPage from './views/GalleryPage';
import HomePage from './views/HomePage';
import LipBlushPage from './views/LipBlushPage';
import PricingPage from './views/PricingPage';


function MetaSync() {
  const location = useLocation();
  const { siteContent } = useSiteContent();

  useEffect(() => {
    document.title = siteContent.meta.title;

    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', siteContent.meta.description);
    }

    window.scrollTo(0, 0);
  }, [location.pathname, siteContent.meta.description, siteContent.meta.title]);

  return null;
}

function AppShell() {
  return (
    <Router>
      <MetaSync />
      <div className="app-shell">
        <HeaderBar />
        <div className="app-shell__content">
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/home" exact>
              <Redirect to="/" />
            </Route>
            <Route path="/about" exact component={AboutPage} />
            <Route path="/before-booking" exact component={ConsentPage} />
            <Route path="/contact" exact component={ContactPage} />
            <Route path="/gallery" exact component={GalleryPage} />
            <Route path="/lip-blush" exact component={LipBlushPage} />
            <Route path="/LipBlush" exact>
              <Redirect to="/lip-blush" />
            </Route>
            <Route path="/Lipblush" exact>
              <Redirect to="/lip-blush" />
            </Route>
            <Route path="/pmu-brows" exact component={BrowsPage} />
            <Route path="/PmuBrows" exact>
              <Redirect to="/pmu-brows" />
            </Route>
            <Route path="/pricing" exact component={PricingPage} />
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </div>
        <FooterBar />
      </div>
    </Router>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppShell />
    </LanguageProvider>
  );
}

export default App;
